<div style="margin-top: 24px; width: 100%">
  <div style="width: 30%; margin: 0 auto">
    <mat-card appearance="outlined">
      <mat-card-header
        style="display: flex; flex-direction: row; justify-content: center; align-items: center"
      >
        <mat-card-title style="font-size: x-large">
          {{ "You don't have access to the DIS" }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <h2>{{ 'Possible reasons' }}:</h2>
        <ul>
          <li>{{ "You don't have any permission" }}</li>
          <li>{{ 'Your user account is no longer active' }}</li>
          <li>{{ 'Other technical issue' }}</li>
        </ul>
        <br />
        <strong>{{ 'Please contact Tanja Jansen or Irina Brose for assistance' }}</strong>
      </mat-card-content>
    </mat-card>
  </div>
</div>
